import { withChartLayout } from 'components/common';
import SeizureActivityDocumentation from 'components/features/chart/special-charts/seizure-activity-documentation/SeizureActivityDocumentation';

const SeizureActivityDocumentationPage = withChartLayout('Seizure Activity Documentation')(SeizureActivityDocumentation);
export default SeizureActivityDocumentationPage;
